import { UserPasswordRepository } from "@/domain/repository/user-password-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ChangePasswordUsecase {
  constructor(private readonly userPasswordRepo: UserPasswordRepository) {}

  async execute(oldPassword: string, newPassword: string): Promise<SATResult<void, SATError>> {
    return this.userPasswordRepo.changePassword(oldPassword, newPassword);
  }
}
